import { colors } from "./Colors";
import { PrimaryFont, SecondaryFont, typeScale } from "./typography";

export const defaultTheme = {
  bgColor: colors.mainblue,
  textColor: colors.ivory100,
  typeScale,
  PrimaryFont, //equiv to PrimaryFont: PrimaryFont,
  SecondaryFont,
  status: {
    notFoundColor: colors.beige200,
    hoverColor: colors.beige200,
  },
};
